export function debounce(
  wait: number
): <F extends (...args: any[]) => any>(
  func: F
) => (...args: Parameters<F>) => () => void {
  let timeout: NodeJS.Timeout | undefined
  return <F extends (...args: any[]) => any>(func: F) => (
    ...args: Parameters<F>
  ) => {
    timeout && clearTimeout(timeout)
    timeout = undefined
    return () => {
      timeout = setTimeout(() => {
        func(...args)
      }, wait)
    }
  }
}

export function delay(wait: number) {
  return <F extends (...args: any[]) => any>(callback: F) => (
    ...args: Parameters<F>
  ) => (): Promise<ReturnType<F>> =>
    new Promise((resolve) => {
      setTimeout(() => resolve(callback(...args)), wait)
    })
}

export function onDebounceFunction(
  callback: () => void,
  timerRef: React.MutableRefObject<NodeJS.Timeout | undefined>,
  time: number
) {
  if (timerRef.current) clearTimeout(timerRef.current)
  timerRef.current = setTimeout(() => {
    callback()
  }, time)
}
